/* begin general import */
import { API_LOGIN_CONFIGURATION_PREFIX } from "config/api-consts";
import { LOGIN_CONFIGURATION_ROUTE } from "config/route-consts";
import { LoginConfigurationFilter } from "models/LoginConfiguration";
import { StatusFilter } from "models/Status";
import React from "react";
import { useTranslation } from "react-i18next";
import { IdFilter, StringFilter } from "react3l-advanced-filters";
import AdvanceIdFilter from "react3l-ui-library/build/components/AdvanceFilter/AdvanceIdFilter";
import AdvanceStringFilter from "react3l-ui-library/build/components/AdvanceFilter/AdvanceStringFilter";
import Drawer, {
  DrawerProps,
} from "react3l-ui-library/build/components/Drawer/Drawer";
import { Reducer } from "redux";
import { loginConfigurationRepository } from "repositories/login-configuration-repository";
import { authorizationService } from "services/common-services/authorization-service";
import {
  FilterAction,
  filterReducer,
  filterService,
} from "services/page-services/filter-service";

/* end individual import */

export interface LoginConfigurationFilterProps extends DrawerProps {
  filter?: any;
  setVisible?: any;
  handleChangeAllFilter?: (data: any) => void;
}

function LoginConfigurationAdvanceFilter(props: LoginConfigurationFilterProps) {
  const [translate] = useTranslation();

  const { validAction } = authorizationService.useAuthorizedAction(
    LOGIN_CONFIGURATION_ROUTE.split("/")[
      LOGIN_CONFIGURATION_ROUTE.split("/").length - 1
    ],
    API_LOGIN_CONFIGURATION_PREFIX
  );

  const { visible, filter, setVisible, handleChangeAllFilter, handleClose } =
    props;

  const [modelFilter, setModelFilter] = React.useReducer<
    Reducer<LoginConfigurationFilter, FilterAction<LoginConfigurationFilter>>
  >(filterReducer, filter);

  const { handleChangeInputFilter, handleChangeSelectFilter } =
    filterService.useFilter(filter, setModelFilter);

  const handleSaveModelFilter = React.useCallback(() => {
    handleChangeAllFilter(modelFilter);
    setVisible(false);
  }, [handleChangeAllFilter, modelFilter, setVisible]);

  const handleClearModelFilter = React.useCallback(() => {
    setModelFilter({
      type: 0,
      payload: new LoginConfigurationFilter(),
    });
  }, [setModelFilter]);

  return (
    <Drawer
      visible={visible}
      handleSave={handleSaveModelFilter}
      handleCancel={handleClearModelFilter}
      handleClose={handleClose}
      visibleFooter={true}
      loading={false}
      size={"sm"}
      title={translate("general.drawer.filter")}
      titleButtonCancel={translate("general.actions.clear")}
      titleButtonApply={translate("general.actions.apply")}
    >
      <div className="d-flex m-t--sm">
        <AdvanceStringFilter
          label={translate("loginConfigurations.code")}
          showCount={true}
          maxLength={100}
          value={modelFilter["code"]["contain"]}
          onChange={handleChangeInputFilter({
            fieldName: "code",
            fieldType: "contain",
            classFilter: StringFilter,
          })}
          placeHolder={translate("loginConfigurations.placeholder.code")}
        />
      </div>

      <div className="d-flex m-t--sm">
        <AdvanceStringFilter
          label={translate("loginConfigurations.name")}
          showCount={true}
          maxLength={100}
          value={modelFilter["name"]["contain"]}
          onChange={handleChangeInputFilter({
            fieldName: "name",
            fieldType: "contain",
            classFilter: StringFilter,
          })}
          placeHolder={translate("loginConfigurations.placeholder.name")}
        />
      </div>
      {validAction("filterListStatus") && (
        <div className="d-flex m-t--sm">
          <AdvanceIdFilter
            value={modelFilter["statusValue"]}
            onChange={handleChangeSelectFilter({
              fieldName: "status",
              fieldType: "equal",
              classFilter: IdFilter,
            })}
            classFilter={StatusFilter}
            getList={loginConfigurationRepository.filterListStatus}
            placeHolder={translate("loginConfigurations.placeholder.status")}
            label={translate("loginConfigurations.status")}
          />
        </div>
      )}
    </Drawer>
  );
}

export default LoginConfigurationAdvanceFilter;
